<template>
  <div>
    <authorize v-if="!isAuthorized"></authorize>
    <select-page v-else></select-page>
  </div>
</template>

<script>
  import facebookServices from '@/services/facebook/facebook.service'
  import Authorize from './Authorize'
  import SelectFacebookPage from './SelectFacebookPage'

  export default {
    components: {
      authorize: Authorize,
      'select-page': SelectFacebookPage
    },

    store: {
      loginStatus: 'administration.channelDetail.facebook.loginStatus'
    },

    computed: {
      isAuthorized() {
        return this.loginStatus.status === 'connected'
      }
    },

    mounted() {
      facebookServices.getLoginStatus()
        .then(loginStatus => { this.loginStatus = loginStatus })
    }
  }
</script>
